import { createParticles, hexToRgb } from '~/utils/function';
import './index.less';
import { Flex } from 'antd';
import { useEffect, useState } from 'react';
import { GlobeHemisphereWest, Lightbulb, Rocket } from '@phosphor-icons/react';
import { FaIndustry } from 'react-icons/fa';

function createLines() {
  return Array.from({ length: 5 }).map((item, index) => {
    // 随机位置
    const left = Math.random() * 100;

    // 随机动画延迟
    const delay = Math.random() * 8;
    return (
      <div
        key={index}
        className="neon-line"
        style={{ left: `${left}%`, animationDelay: `${delay}s` }}
      ></div>
    );
  });
}

function createStars() {
  return Array.from({ length: 5 }).map((item, index) => {
    // 随机位置
    const left = Math.random() * 100;
    const top = Math.random() * 100;
    return (
      <div
        key={index}
        className="star"
        style={{
          left,
          top,
          animationDelay: `${Math.random() * 3}s`,
        }}
      ></div>
    );
  });
}

function createRays() {
  return Array.from({ length: 5 }).map((item, index) => {
    const ray = document.createElement('div');
    ray.className = 'ray';

    // 随机动画延迟
    const delay = Math.random() * 2;

    return (
      <div
        className="ray"
        key={index}
        style={{
          transform: `rotate(${index * 30}deg) translateY(-40px)`,
          animationDelay: `${delay}s`,
        }}
      ></div>
    );
  });
}

const AboutUs = () => {
  const [activeValue, setActiveValue] = useState(0);

  // 核心价值数据
  const coreValues = [
    {
      id: 0,
      title: '技术革新',
      subtitle: '引领人工智能技术前沿发展',
      description:
        '以自主研发为核心驱动力，致力于通过创新技术重构行业生态，持续探索AI技术的边界，将先进算法与实际应用场景深度融合。',
      icon: <Rocket size={28} />,
      color: '#4facfe',
    },
    {
      id: 1,
      title: '自主研发',
      subtitle: '以创新技术驱动行业发展',
      description:
        "构建高度集成、自动化的视频工业化流水线，推动行业从传统制作模式向标准化、规模化、智能化的'工业化2.0时代'跃迁。",
      icon: <Lightbulb size={28} />,
      color: '#00f2fe',
    },
    {
      id: 2,
      title: '工业化2.0',
      subtitle: '推动视频制作标准化、规模化、智能化',
      description:
        "通过构建高度集成、自动化的视频工业化流水线，推动行业从传统制作模式向标准化、规模化、智能化的'工业化2.0时代'跃迁。",
      icon: <FaIndustry />,
      color: '#ffd700',
    },
    {
      id: 3,
      title: '全球视野',
      subtitle: '为全球创作者提供下一代视频解决方案',
      description:
        '通过技术赋能与生态整合，持续强化在视频生产领域的开创者地位，为全球内容创作者提供高效、精准、可扩展的下一代视频解决方案。',
      icon: <GlobeHemisphereWest size={28} />,
      color: '#ff6b6b',
    },
  ];
  // 处理核心价值项点击
  const handleValueClick = (id: number) => {
    setActiveValue(id);
  };
  useEffect(() => {
    // 自动轮播
    const interval = setInterval(() => {
      setActiveValue((prev) => (prev + 1) % coreValues.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel-slide carousel-five-slide">
      <div className="carousel-five-tech-grid"></div>
      <div className="carousel-five-neon-lines">{createLines()}</div>
      <div className="carousel-five-hologram-effect"></div>

      <div className="carousel-five-floating-elements">
        <div className="carousel-five-floating-element"></div>
        <div className="carousel-five-floating-element"></div>
        <div className="carousel-five-floating-element"></div>
        <div className="carousel-five-floating-element"></div>
      </div>

      <div className="carousel-five-particles-container">{createParticles()}</div>

      <Flex className="container carousel-content-wrapper carousel-five-wrapper" align="center">
        <div className="flex-1 carousel-five-content pr-[40px]">
          <div className="carousel-five-header">
            <h1 className="carousel-five-company-name">企业核心价值</h1>
          </div>
          <div className="carousel-features">
            {coreValues.map((value, index) => (
              <div
                key={`${value.id}_${index}`}
                className={`carousel-five-value-item ${activeValue === index ? 'active' : ''}`}
                onClick={() => handleValueClick(index)}
                style={{ borderLeftColor: value.color }}
              >
                <div className="carousel-five-value-header">
                  <div
                    className="carousel-five-value-icon"
                    style={{
                      background: `rgba(${hexToRgb(value.color)}, 0.2)`,
                      color: value.color,
                    }}
                  >
                    {value.icon}
                  </div>
                  <div>
                    <h2 className="carousel-five-value-title" style={{ color: value.color }}>
                      {value.title}
                    </h2>
                    <div className="carousel-five-value-subtitle">{value.subtitle}</div>
                  </div>
                </div>
                {/* <p className="value-description">{value.description}</p> */}
              </div>
            ))}
          </div>
        </div>
        <Flex className="flex-1" align="center" justify="center">
          <div className="carousel-five-animation-container">
            {/* 技术革新动画 */}
            <div
              className={`carousel-five-animation-scene carousel-five-rocket-animation ${activeValue === 0 ? 'active' : ''}`}
            >
              <div className="carousel-five-rocket"></div>
              <div className="carousel-five-stars">{createStars()}</div>
            </div>

            {/* 自主研发动画 */}
            <div
              className={`carousel-five-animation-scene carousel-five-bulb-animation ${activeValue === 1 ? 'active' : ''}`}
            >
              <div className="carousel-five-bulb"></div>
              <div className="carousel-five-light-rays">{createRays()}</div>
            </div>

            {/* 工业化2.0动画 */}
            <div
              className={`carousel-five-animation-scene carousel-five-gears-animation ${activeValue === 2 ? 'active' : ''}`}
            >
              <div className="carousel-five-gear-large"></div>
              <div className="carousel-five-gear-small"></div>
            </div>

            {/* 全球视野动画 */}
            <div
              className={`carousel-five-animation-scene carousel-five-earth-animation ${activeValue === 3 ? 'active' : ''}`}
            >
              <div className="carousel-five-earth"></div>
              <div className="carousel-five-orbit"></div>
              <div className="carousel-five-satellite"></div>
            </div>
          </div>
        </Flex>
      </Flex>
    </div>
  );
};

export default AboutUs;
